import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { forkJoin, map, Observable } from 'rxjs';

import { skipMessagingKey } from '../../../../core/services/http.context';
import { MessagingEnvironmentService } from '../../../../core/services/messaging-environment.service';
import { IMessageableEntity } from '../../interfaces/IMessageableEntity';
import { IRepairOrder } from '../../interfaces/IRepairOrder';
import { MessagingApiStateService } from './messaging-api-state.service';

@Injectable()
export class IntegrationsApiService {
  constructor(
    private httpClient: HttpClient,
    private env: MessagingEnvironmentService,
    private state: MessagingApiStateService
  ) {}

  getRepairOrder(orderID: string): Observable<{ repairOrder: IRepairOrder; video: string | null }> {
    const accountUid = this.state.user?.subAccountMessageableEntity?.businessReference?.entityUID ?? '';
    const orderRequest = this.httpClient.get<IRepairOrder>(
      `${this.env.env.ordersAPI}/repair-order/${orderID}?account-uid=${accountUid}`,
      { context: skipMessagingKey() }
    );
    const orderVideos = this.httpClient.get<{ videoLink: string }[]>(
      `${this.env.env.ordersAPI}/repair-order/${orderID}/customer-videos?account-uid=${accountUid}`,
      { context: skipMessagingKey() }
    );
    return forkJoin([orderRequest, orderVideos]).pipe(
      map((e) => {
        return { repairOrder: e[0], video: e[1][0]?.videoLink || null };
      })
    );
  }

  getRepairOrderByJobName(job: string) {
    const accountUid = this.state.user?.subAccountMessageableEntity?.businessReference?.entityUID ?? '';
    return this.httpClient.post<{ orderId: string }>(
      `${this.env.env.ordersAPI}/repair-order/order-id?account-uid=${accountUid}`,
      { jobServiceNumber: job },
      { context: skipMessagingKey() }
    );
  }

  getTokenVideoCall(channelId: string) {
    return this.httpClient.post<{ token: string }>(`${this.env.env.apiUrl + this.env.env.messagingApiPath}/agora/token`, {
      roomName: channelId,
    });
  }

  leaveCallRoom(room: string, participantID: string) {
    return this.httpClient.post(`${this.env.env.apiUrl + this.env.env.messagingApiPath}/call-room/leave`, {
      roomName: room,
      participantID,
    });
  }

  joinCallRoom(room: string, participantID: string) {
    return this.httpClient.post<{ participants: { uid: string; messageableEntity: IMessageableEntity }[] }>(
      `${this.env.env.apiUrl + this.env.env.messagingApiPath}/call-room/join`,
      { roomName: room, participantID }
    );
  }
}
